<template>
  <v-card :elevation="1">
    <v-expansion-panels class="active" focusable>
      <v-expansion-panel-header class="list-item-height">
        <v-container fluid fill-height pa-0 ma-0>
          <v-row no-gutters align="center">
            <v-col cols="auto">
              <!-- Left side credit icon -->
              <!--              <v-icon class="mr-2">mdi-credit-card</v-icon>-->
              <v-icon color="primary" v-text="'mdi-credit-card'" />
            </v-col>
            <v-col>
              <v-col cols="12">
                <span class="title-card-item-component"
                  >App {{ $t("customerProfile.credits") }}:
                  {{
                    $appFormatters.formatMoney($store.getters.user.credits)
                  }}.</span
                >
              </v-col>
            </v-col>
          </v-row>
        </v-container>
        <template v-slot:actions>
          <v-switch
            v-model="switchValue"
            @change="handleSwitchChange"
          ></v-switch>
        </template>
      </v-expansion-panel-header>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  name: "CreditToggle",
  data() {
    return {
      message: "sub title",
      switchValue:
        this.$store.getters.user && this.$store.getters.user?.credits > 0, // Initial value of the v-switch
    };
  },
  beforeMount() {
    this.$store.dispatch(
      "checkout/setUseCredit",
      this.$store.getters.user && this.$store.getters.user?.credits > 0
    );
    this.$store.dispatch("cart/setLoad");
  },
  methods: {
    handleSwitchChange(newValue) {
      this.$store.dispatch("checkout/setUseCredit", newValue);
      this.$store.dispatch("cart/setLoad");
    },
  },
};
</script>
